import styled from "@react-pdf/styled-components";

export const Page = styled.Page`
  padding: ${(props) =>
    props.orientation === "landscape" ? "10px 15px" : "25px 15px"};
`;

export const Row = styled.View`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
`;

export const Col = styled.View`
  width: ${(props) => props.width || "50%"};
  margin-bottom: 6px;
`;

export const CompanyLogo = styled.Image`
  max-height: 80px;
  max-width: 80px;
  height: auto;
  width: auto;
`;

export const HeaderRow = styled(Row)`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SectionContainer = styled.View`
  border: 1px #e1e1e1;
`;

export const SectionTitleContainer = styled.View`
  background-color: #eaecee;
  padding: 5px;
`;

export const SectionTitle = styled.Text`
  color: #212f3d;
  font-size: 10px;
  margin-left: 3px;
`;

export const SectionContentContainer = styled(Row)`
  padding: 5px 10px;
`;

export const Text = styled.Text`
  color: #4e4e4e;
  font-size: 10px;
  width: 50%;
`;

export const TableTitle = styled.Text`
  font-size: ${(props) => (props.size === "small" ? "12px" : "14px")};
  margin: 4px 0 1px 2px;
`;

export const TableCell = styled.Text`
  width: 100%;
  color: #4e4e4e;
  background-color: ${(props) => (props.disabled ? "#AAAAAA" : "white")};
  padding: 0px 3px;
  font-size: ${(props) => (props.size === "small" ? "9px" : "11px")};
  text-align: ${(props) => (props.header ? "left" : "center")};
  margin: ${(props) => (!props.disabled ? "2px 0px 0px 0px" : "0px")};
  height: ${(props) => (props.isLongText ? "27px" : "18px")};

  // font-family: MicrosoftBlack;
`;

export const TableCol = styled.View`
  width: ${(props) => props.width || "auto"};
  flex-direction: col;
`;

export const TableRow = styled.View`
  border-style: solid;
  border-width: 0.5px;
  border-left-width: 0;
  border-top-width: 0;
  height: ${(props) => (props.isLongText ? "27px" : "18px")};
`;

export const TableOutline = styled.View`
  display: flex;
  flex-direction: row;
  width: auto;
  border-style: solid;
  border-width: 0.5px;
  border-right-width: 0;
  border-bottom-width: 0;
`;
